import pushGTMEvent from '@helpers/analyticsHelpers/pushGTMEvent';

export type TrackingSource =
  | 'from_icon_header'
  | 'from_ecommerce_promotion_card'
  // On checkout page
  | 'from_checkout'
  // User goes to checkout page from cart page without selecting delivery option
  | 'after_cart'
  // When product is added to cart
  | 'after_add_to_cart';

const trackCloseDeliveryPicker = () => {
  pushGTMEvent({
    event: 'Track',
    category: 'delivery_widget',
    action: 'delivery_widget_closed',
    label: '',
    value: 0,
  });
};

// Only when user does not have delivery option selected
const trackDeliveryPickerOpened = (label?: TrackingSource, hasPreviousSelectedDeliveryOption: boolean = false) => {
  pushGTMEvent({
    event: 'Track',
    category: 'delivery_widget',
    action: hasPreviousSelectedDeliveryOption ? 'change_delivery_widget_opened' : 'delivery_widget_opened',
    label: label || '',
    value: 0,
  });
};

export { trackDeliveryPickerOpened, trackCloseDeliveryPicker };
